import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./auth-context";
import { VerifyEmailWall } from "./verify-email-wall";

/** Second gate (after RequireAuth) for the authenticated app. Mirrors the iOS
 *  RootView ordering: send fresh accounts through onboarding first, then hard-
 *  block on email verification when the server is enforcing it. Both are no-ops
 *  for an established, verified user. */
export function RequireOnboarded({ children }: { children: ReactNode }) {
  const { needsOnboarding, user } = useAuth();

  if (needsOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }
  if (user?.must_verify_email) {
    return <VerifyEmailWall />;
  }
  return <>{children}</>;
}
